import { useRecoilValue } from "recoil";
import { solanaPrice } from "../coins";

export const useSolanaPrice = (): number => {
    const price = useRecoilValue(solanaPrice);
    return price;
};
